import { IoChevronForward } from "react-icons/io5";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { customerAtom } from "../auth";
import { Post } from "./Post";

// 生年月日未登録の顧客に出す登録導線バナー（登録で500円・誕生月1,000円クーポン）。
// SMSの短縮リンク着地画面（注文詳細など）でも表示できるよう、
// customerAtom が空なら自前で顧客情報を取得する。登録済みなら何も表示しない。
export const BirthdayBanner = ({ style = {} }) => {
  const [customer, setCustomer] = useAtom(customerAtom);
  useEffect(() => {
    let unmounted = false;
    if (!customer || !customer.id) {
      (async () => {
        const r = await Post('post', '/customer/index.php', {});
        if (!unmounted && r?.result === 1 && r.customer) setCustomer(r.customer);
      })();
    }
    return () => { unmounted = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!customer || !customer.id || customer.birthday) return null;
  return (
    <Link to="/profile" className="d-block" style={{ textDecoration: 'none', ...style }}>
      <div style={{ background: '#fdf2f8', border: '1px solid #f9a8d4', borderRadius: 10, padding: '12px 14px', color: '#9d174d', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ fontSize: 14, textAlign: 'left' }}>🎂 生年月日のご登録で<b>500円クーポン</b>進呈！お誕生月には毎年<b>1,000円クーポン</b>をお届けします</span>
        <IoChevronForward />
      </div>
    </Link>
  );
};
